export * from './Tabs.Skeleton';
import _default from './Tabs';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/carbon-components-react/es/components/Tabs/index.js
// module id = 721
// module chunks = 15